export interface ImageSearchParameters {
    search: SearchOptions;
    options: Options;
}

export interface SearchOptions {
    types: ['wmammodularcontent_generic_image'];
    wmamodularcontent0frontend_image0component: '@ap/background-image';
    wmamodularcontent0frontend_image0key: string;
    wmamodularcontent0frontend_image0brand: ImageBrand;
}

interface Options {
    fullExport: boolean;
}

export enum ImageBrand {
    ASN = 'ASN',
    SNS = 'SNS',
    REB = 'RB',
    BLG = 'BLG'
}

export interface ImageSearchResult {
    metadata: {
        id: number;
        identifier: string;
        image_filename: string;
        image_url: string;
        item_metadata: {
            brand: {
                id: string;
                name: ImageBrand;
            };
            component: {
                identifier: number;
                tag: string;
            };
            key: string;
            link_url: string;
            text_1: string;
            text_2: string;
            text_3: string;
            text_title: string;
        };
        lastmodified_date: string;
        publication_date: string;
        tags: string[];
        width: number;
    };
    subtype: string;
    title: string;
    type: string;
    url: string;
}

export interface ImageSearchResponse {
    results: ImageSearchResult[];
}
